import { pdfjs } from 'react-pdf';

export type Change = AnnotationChange | AnnotationAdd;

export interface AnnotationChange {
  type: 'change';
  id: string;
  originalFieldName: string; // used by rosetta to make updates

  fieldName?: string;
  // x1, y1, x2, y2
  rect?: [number, number, number, number];
  deleted?: boolean;
}

export enum AnnotationAddType {
  TEXTBOX = 'textbox',
  CHECKBOX = 'checkbox',
  SIGNATURE = 'signature',
}

export enum Signer {
  APPLICANT = 'applicant',
  COAPPLICANT = 'coapplicant',
  MANAGER = 'manager',
}

export enum Signature {
  SIGNATURE = 'signature',
  INITIALS = 'initials',
}

export interface AnnotationAddMetaType {
  type: AnnotationAddType;
  // Below fields are for the signature type only
  signer?: Signer | undefined;
  signature?: Signature | undefined;
}

export interface AnnotationAdd {
  type: 'add';
  id: string;
  pageIndex: number;
  fieldType: AnnotationAddType;
  fieldName: string;
  rect: [number, number, number, number];
}

export function isAnnotationAdd(change: Change): change is AnnotationAdd {
  return change.type === 'add';
}
export function isAnnotationChange(change: Change): change is AnnotationChange {
  return change.type === 'change';
}

export type AnnotationLike = pdfjs.PDFAnnotationData | AnnotationAdd;
